import { render, staticRenderFns } from "./commission_order_detail.vue?vue&type=template&id=9923720e&scoped=true"
import script from "./commission_order_detail.vue?vue&type=script&lang=js"
export * from "./commission_order_detail.vue?vue&type=script&lang=js"
import style0 from "./commission_order_detail.vue?vue&type=style&index=0&id=9923720e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9923720e",
  null
  
)

export default component.exports